import * as Sentry from "@sentry/react";

/**
 * Initialize Sentry React. Mirrors the Vue installSentry config (same env vars,
 * same release/environment sourcing), minus the Vue-specific app binding.
 */
export function installSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) {
    console.warn("[Sentry] DSN ausente. Eventos não serão enviados.");
    return;
  }

  const tracesSampleRate = Number(
    import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? "0",
  );
  const replaysSessionSampleRate = Number(
    import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ?? "0",
  );
  const replaysOnErrorSampleRate = Number(
    import.meta.env.VITE_SENTRY_REPLAYS_ERROR_SAMPLE_RATE ?? "0",
  );

  const integrations: any[] = [Sentry.browserTracingIntegration()];
  if (replaysSessionSampleRate > 0 || replaysOnErrorSampleRate > 0) {
    integrations.push(
      Sentry.replayIntegration({
        blockAllMedia: false,
        maskAllInputs: false,
        maskAllText: false,
      }),
    );
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE || "development",
    integrations,
    release: (import.meta.env.VITE_APP_VERSION as string) || "unknown",
    debug: import.meta.env.DEV === true,
    tracesSampleRate,
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
  });
}
